var map = {
	"./wallpaper-01.png": 43795,
	"./wallpaper-02.png": 69304,
	"./wallpaper-03.png": 37569,
	"./wallpaper-04.png": 1454,
	"./wallpaper-05.png": 44471,
	"./wallpaper-06.png": 60188,
	"./wallpaper-07.png": 73253,
	"./wallpaper-08.png": 42658,
	"./wallpaper-09.png": 63787,
	"./wallpaper-10.png": 58485,
	"./wallpaper-11.png": 89388,
	"./wallpaper-12.png": 9447,
	"./wallpaper-13.jpg": 50458
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29241;